"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _modal.Modal;
  }
});
Object.defineProperty(exports, "IeModal", {
  enumerable: true,
  get: function get() {
    return _modal.IeModal;
  }
});
Object.defineProperty(exports, "ModalBackgroundStyled", {
  enumerable: true,
  get: function get() {
    return _modal.ModalBackgroundStyled;
  }
});
Object.defineProperty(exports, "BodyOverflowStyled", {
  enumerable: true,
  get: function get() {
    return _modal.BodyOverflowStyled;
  }
});
Object.defineProperty(exports, "ModalWrapperStyled", {
  enumerable: true,
  get: function get() {
    return _modal.ModalWrapperStyled;
  }
});
Object.defineProperty(exports, "ModalBody", {
  enumerable: true,
  get: function get() {
    return _modal.ModalBody;
  }
});
Object.defineProperty(exports, "ModalBodyStyled", {
  enumerable: true,
  get: function get() {
    return _modal.ModalBodyStyled;
  }
});
Object.defineProperty(exports, "ModalDialog", {
  enumerable: true,
  get: function get() {
    return _modal.ModalDialog;
  }
});
Object.defineProperty(exports, "Dialog", {
  enumerable: true,
  get: function get() {
    return _modal.Dialog;
  }
});
Object.defineProperty(exports, "ModalFooter", {
  enumerable: true,
  get: function get() {
    return _modal.ModalFooter;
  }
});
Object.defineProperty(exports, "ModalFooterStyled", {
  enumerable: true,
  get: function get() {
    return _modal.ModalFooterStyled;
  }
});
Object.defineProperty(exports, "ModalHeader", {
  enumerable: true,
  get: function get() {
    return _modal.ModalHeader;
  }
});
Object.defineProperty(exports, "ModalHeaderStyled", {
  enumerable: true,
  get: function get() {
    return _modal.ModalHeaderStyled;
  }
});
Object.defineProperty(exports, "ModalBackgroundProps", {
  enumerable: true,
  get: function get() {
    return _modal.ModalBackgroundProps;
  }
});
Object.defineProperty(exports, "ModalProps", {
  enumerable: true,
  get: function get() {
    return _modal.ModalProps;
  }
});
Object.defineProperty(exports, "ModalStaticProps", {
  enumerable: true,
  get: function get() {
    return _modal.ModalStaticProps;
  }
});

var _modal = require("./components/modal");